// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"LMSnCTGn0I"};